import React from 'react';

import { Root } from './Tag.style';

export const Tag = ({ children, ...props }) => {
  return <Root {...props}>{children}</Root>;
};
